import React from 'react';

const InstagramStoriesAd = ({
  image,
  message,
  buttonText = 'Learn More',
  website = 'automateb.com',
}) => {
  return (
    <div
      style={{
        width: '250px',
        height: '445px',
        border: '1px solid #ccc',
        borderRadius: '1rem',
        overflow: 'hidden',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        fontFamily: 'sans-serif',
        backgroundColor: '#fff',
        position: 'relative',
      }}
    >
      {/* Blurred Background Image */}
      <img
        src={image}
        alt="background"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          filter: 'blur(10px) brightness(0.7)',
          zIndex: 0,
        }}
      />

      {/* Top bar with logo and sponsored tag */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '0.5rem',
          justifyContent: 'space-between',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          zIndex: 2,
          color: 'white',
          fontSize: '0.7rem',
          fontWeight: 'bold',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
          <img
            src="https://bmsinfoglobal.com/wp-content/uploads/2023/05/bmslogo2.png"
            alt="insta"
            style={{
              width: 25,
              height: 25,
              borderRadius: '50%',
              backgroundColor: 'white',
              objectFit: 'contain',
            }}
          />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontSize: '0.75rem' }}>brightmediasolution</span>
            <span style={{ fontSize: '0.55rem', fontWeight: 'normal' }}>
              Sponsored
            </span>
          </div>
        </div>
        <span style={{ fontWeight: 'bolder' }}>×</span>
      </div>

      {/* Foreground image (centered) */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          height: '60%',
          zIndex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img
          src={image}
          alt="Story Ad"
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            // borderRadius: '0.5rem',
            objectFit: 'contain',
          }}
        />
      </div>

      {/* Overlay with text and button */}
      <div
        style={{
          position: 'absolute',
          bottom: '1.5rem',
          width: '100%',
          textAlign: 'center',
          color: 'white',
          textShadow: '0 0 3px rgba(0,0,0,0.7)',
          zIndex: 2,
        }}
      >
        <div style={{ fontWeight: 'bold', fontSize: '1rem', marginBottom: '0.25rem' }}>
          Bright Media Solution
        </div>
        <div style={{ fontSize: '0.65rem', marginBottom: '0.75rem' }}>{website}</div>
        <button
          style={{
            backgroundColor: 'white',
            color: '#1d4ed8',
            border: 'none',
            borderRadius: '1rem',
            padding: '0.4rem 1rem',
            fontWeight: 'bold',
            fontSize: '0.7rem',
            cursor: 'pointer',
            boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
          }}
        >
          <i className="fa fa-link" style={{ marginRight: '5px' }} />
          {buttonText.toUpperCase()}
        </button>
      </div>
    </div>
  );
};

export default InstagramStoriesAd;
